/**
 * Created by jonas on 2020-10-03.
 */
import {MatrixUtils} from "./ArrayUtils";


export interface StateMatrixCoordinate{
    column:number;
    row:number;
}
export class StateMatrix<T> {
    get matrix():T[][] {
        return this._matrix;
    }

    set matrix(value:T[][]) {
        this._matrix = value;
    }

    private _matrix:T[][];
    public readonly columns:number;
    public readonly rows:number;

    constructor(initMatrix?:T[][]) {
        this._matrix = initMatrix ? MatrixUtils.cloneMatrix(initMatrix) : [];
    }

    public initWithValue(columns:number, rows:number, initValue:T){
        this._matrix = [];
        for (let i:number = 0; i < columns; i++){
            this._matrix.push([]);
            for (let j:number = 0; j < rows; j++){
                this._matrix[i].push(initValue);
            }
        }
    }

    public getAllCoordinateForValue(value:T):StateMatrixCoordinate[] {
        const result:StateMatrixCoordinate[] = []
        for (let i:number = 0; i < this._matrix.length; i++){
            for (let j:number = 0; j < this._matrix[i].length; j++){
                if (this._matrix[i][j] === value){
                    result.push({column:i,row:j});
                }

            }
        }
        return result;
    }

    /**
     *
     * @param callback (value:T,column?:number,row?:number)=>boolean. Function to execute on each element.
     */
    public getAllCoordinatesWhere(callback:(value:T,column?:number,row?:number)=>boolean):StateMatrixCoordinate[] {
        const result:StateMatrixCoordinate[] = []
        for (let i:number = 0; i < this._matrix.length; i++){
            for (let j:number = 0; j < this._matrix[i].length; j++){
                if (callback(this._matrix[i][j], i, j)){
                    result.push({column:i,row:j});
                }

            }
        }
        return result;
    }

    public static convertStateCoordinatesToTuples(coords:StateMatrixCoordinate[]):[number,number][]{
        const result:[number,number][] = [];
        for (let coord of coords){
            result.push(StateMatrix.convertStateCoordinateToTuple(coord));
        }
        return result;
    }

    public static convertStateCoordinateToTuple(coord:StateMatrixCoordinate):[number,number]{
        return [coord.column, coord.row];
    }
}